export default __webpack_public_path__ + "static/media/eb-wht-2.619900b3.png";